<template>
    <div>
        <b-modal id="modal-detail-perkin" v-model="showModal" size="xl" hide-footer ok-only ok-title="Ok"
            title="Detail Monitoring Perkin" @hidden="onModalClose" @ok="onModalConfirm">
            <div>
                <PerkinIndividu :fD="dataModal" :loadingData="isLoadGetData" :perkinData="perkinIndividuData" />
                <div v-if="dataModal.jenis_perkin == 'gabungan'">
                    <PerkinGabungan v-if="Object.keys(perkinGabunganData).length > 0" :fD="dataModal" :loadingData="isLoadGetData"
                        :perkinData="perkinGabunganData" />
                </div>
            </div>
        </b-modal>
    </div>
</template>
  
<script>
import { ref, onMounted, watchEffect, nextTick } from '@vue/composition-api'
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { parserValue } from '@/libs/helper'
import { VBTooltip, BButton } from 'bootstrap-vue'
import perkin from "@/composables/b/perkin";
import { VueGoodTable } from "vue-good-table";
import PerkinIndividu from "./PerkinIndividu.vue";
import PerkinGabungan from "./PerkinGabungan.vue";

export default {
    props: {
        show: { Boolean, required: true },
        dataModal: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        VueGoodTable,
        PerkinIndividu,
        PerkinGabungan
    },
    methods: {
        onModalClose() {
            this.$emit('closeDialog');
        },
        onModalConfirm() {
            this.$emit('confirmDialog');
        },
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    setup(props, context) {
        const g = context.root;
        const cookiesRolesB = ref(g.$cookies.get("roles_b"));
        const showModal = ref(false);
        const formDatas = ref({});
        const isLoadGetData = ref(false);
        const perkinData = ref();
        const perkinIndividuData = ref({
            persiapan_tw_1: null,
            persiapan_tw_2: null,
            persiapan_tw_3: null,
            persiapan_tw_4: null,
            persiapan_sk_tim_tw_1: null,
            persiapan_sk_tim_tw_2: null,
            persiapan_sk_tim_tw_3: null,
            persiapan_sk_tim_tw_4: null,
            persiapan_ruang_tw_1: null,
            persiapan_ruang_tw_2: null,
            persiapan_ruang_tw_3: null,
            persiapan_ruang_tw_4: null,
            persiapan_bmd_tw_1: null,
            persiapan_bmd_tw_2: null,
            persiapan_bmd_tw_3: null,
            persiapan_bmd_tw_4: null,
            pelaksanaan_tw_1: null,
            pelaksanaan_tw_2: null,
            pelaksanaan_tw_3: null,
            pelaksanaan_tw_4: null,
            pelaksanaan_total_bmd: null,
            pelaksanaan_selesai_inven_tw_1: null,
            pelaksanaan_selesai_inven_tw_2: null,
            pelaksanaan_selesai_inven_tw_3: null,
            pelaksanaan_selesai_inven_tw_4: null,
            pelaporan_tw_1: null,
            pelaporan_tw_2: null,
            pelaporan_tw_3: null,
            pelaporan_tw_4: null,
            pelaporan_ba_tw_1: null,
            pelaporan_ba_tw_2: null,
            pelaporan_ba_tw_3: null,
            pelaporan_ba_tw_4: null,
            pelaporan_sptjm_tw_1: null,
            pelaporan_sptjm_tw_2: null,
            pelaporan_sptjm_tw_3: null,
            pelaporan_sptjm_tw_4: null,
            pelaporan_lhi_tw_1: null,
            pelaporan_lhi_tw_2: null,
            pelaporan_lhi_tw_3: null,
            pelaporan_lhi_tw_4: null,
            akumulasi_bobot_tw_1: null,
            akumulasi_bobot_tw_2: null,
            akumulasi_bobot_tw_3: null,
            akumulasi_bobot_tw_4: null,
            akumulasi_pertw_tw_1: null,
            akumulasi_pertw_tw_2: null,
            akumulasi_pertw_tw_3: null,
            akumulasi_pertw_tw_4: null
        });
        const perkinGabunganData = ref({
            persiapan_tw_1: null,
            persiapan_tw_2: null,
            persiapan_tw_3: null,
            persiapan_tw_4: null,
            pelaksanaan_tw_1: null,
            pelaksanaan_tw_2: null,
            pelaksanaan_tw_3: null,
            pelaksanaan_tw_4: null,
            pelaksanaan_total_bmd: null,
            pelaksanaan_selesai_inven_tw_1: null,
            pelaksanaan_selesai_inven_tw_2: null,
            pelaksanaan_selesai_inven_tw_3: null,
            pelaksanaan_selesai_inven_tw_4: null,
            pelaporan_tw_1: null,
            pelaporan_tw_2: null,
            pelaporan_tw_3: null,
            pelaporan_tw_4: null,
            akumulasi_bobot_tw_1: null,
            akumulasi_bobot_tw_2: null,
            akumulasi_bobot_tw_3: null,
            akumulasi_bobot_tw_4: null,
            akumulasi_pertw_tw_1: null,
            akumulasi_pertw_tw_2: null,
            akumulasi_pertw_tw_3: null,
            akumulasi_pertw_tw_4: null
        });

        const getData = () => {
            isLoadGetData.value = true;
            formDatas.value = {};
            let params = {
                filter_kolok: props.dataModal.kolok,
                username: g.$cookies.get("username"),
            };
            perkin.getDetailPerkin(g, params).then(res => {
                perkinData.value = res.rows;
                isLoadGetData.value = false;
                if (perkinData.value) {
                    perkinIndividuData.value = perkinData.value.filter((item) => {
                        return item.jenis_perkin == 'individu';
                    });
                    perkinIndividuData.value = (perkinIndividuData.value.length > 0) ? perkinIndividuData.value[0] : {};
                    /* Gabungan */
                    perkinGabunganData.value = perkinData.value.filter((item) => {
                        return item.jenis_perkin == 'gabungan';
                    });
                    perkinGabunganData.value = (perkinGabunganData.value.length > 0) ? perkinGabunganData.value[0] : {};
                }

            }).catch(err => {
                isLoadGetData.value = false;
                console.log(err)
            });

        };
        watchEffect(() => {
            showModal.value = props.show;
            if (props.show) {
                getData();
            }
        });

        return {
            cookiesRolesB,
            showModal,
            formDatas,
            isLoadGetData,
            perkinIndividuData,
            perkinGabunganData,
            parserValue,
        }
    },

    data() {
        return {
            required,

        }
    },
}
</script>
<style lang="scss" scoped>
/* Custom CSS for changing background color of table cells on hover */
.table-hover-cell tbody tr td:hover {
    background-color: #d9d9d9;
    /* Change to the desired darker shade */
}

@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>